type RuntimeWindow = typeof window & { ENVIRONMENT?: string };

const getEnvironment = (): string => {
  const runtimeEnv = typeof window !== 'undefined' ? (window as RuntimeWindow).ENVIRONMENT : undefined;
  const buildEnv = process.env.ENVIRONMENT || process.env.NODE_ENV || 'test';
  return (runtimeEnv || buildEnv).toLowerCase();
};

const isProd = (): boolean => {
  const env = getEnvironment();
  return env === 'prod' || env === 'production';
};

const apiUrl = isProd()
  ? 'https://lsw8u2hbah.execute-api.us-east-2.amazonaws.com'
  : 'https://zr3akghm60.execute-api.us-east-2.amazonaws.com';

export const API_ENDPOINTS = {
  READING: apiUrl,
  AUTH: apiUrl,
};

export const getApiEndpoint = (service: keyof typeof API_ENDPOINTS, path: string): string => {
  return `${API_ENDPOINTS[service]}${path}`;
};
